<template>
    <Modal title="物流信息" @on-visible-change="showModal" v-model="show" :closable="false" :mask-closable="false">
        <div style="height: 40px">
            最近更新时间：{{updateTime|long2datetime}}
            <el-button size="small" type="success" @click="ok"  :loading="loading">更新物流信息</el-button>
        </div>
        <Timeline>
            <TimelineItem v-for="(log,ind) in withdrawLogs" :key="ind">
                <p class="time">{{log.ctime|long2datetime}}</p>
                <p class="content">{{log.description}}</p>
            </TimelineItem>
        </Timeline>
        <div slot="footer">
            <el-button size="small" @click="cancel">关闭</el-button>
        </div>
    </Modal>
</template>
<script>
export default {
    name: "CXiapiLogistics",
    data() {
        return {
            loading: false,
            withdrawLogs: [],
            updateTime: 0,
        }
    },
    props: [
        'waybill', 'show'
    ],
    methods: {
        showModal: function(val) {
            if (val) this.getList();
            else {
                this.withdrawLogs = [];
                this.updateTime = 0;
            }
        },
        getList: function() {
            var me = this;
            me.loading = true;
            me.$http.post("/ware/waybill/getLogistisc.action", { ordersn: me.waybill.orderId, trackingNo: me.waybill.waybillOrder }).then(response => {
                var body = response;
                if (body.status == 0) {

                    me.withdrawLogs = body.obj.trackingInfo;
                    me.updateTime = body.obj.updateTime;
                }
                me.loading = false;
            }, response => {
                me.loading = false;
            });
        },
        ok: function() {
            this.getList();
        },
        cancel: function() {
            this.$emit('cancel')
        }

    }
}
</script>
<style scoped>
.ivu-alert-with-desc {
    padding: 0px 16px;
}

.time {
    font-size: 14px;
    font-weight: bold;
}

.content {
    padding-left: 5px;
    word-wrap: break-word;
}
</style>